import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetChartHeatmap } from './useGetChartHeatmap'
import { ChartHeatmapContent } from './ChartHeatmapContent'

export const ChartHeatmapComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetChartHeatmap(id, tileFilterSelections)

  return (
    <ChartHeatmapContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function ChartHeatmapComponentLoading() {
  return 'Loading...'
}
